<script>
import { MONTHS } from '@src/constants/date'
export default {
  props: {
    year: {
      type: Number,
      default: null,
    },
    month: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      daysOfWeek: 7,
      numberOfRows: 5,
    }
  },
  computed: {
    title() {
      if (this.year && this.month) {
        return this.year + ', ' + MONTHS[this.month - 1].value
      }
      return 'Day Picker'
    },
    lastDate() {
      return new Date(this.year, this.month, 0).getDate()
    },
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    getIndex(row, column) {
      return row * this.daysOfWeek + column + 1
    },
    isIndexValid(row, column) {
      if (this.getIndex(row, column) <= this.lastDate) {
        return true
      }
      return false
    },
    setDay(index) {
      this.$emit('set-day', index)
    },
  },
}
</script>

<template>
  <v-card>
    <v-card-title class="primary--text justify-center">{{
      title
    }}</v-card-title>
    <v-card-text>
      <v-row
        v-for="(rowIndex, i) in numberOfRows"
        :key="'dayRowIndex-' + rowIndex"
      >
        <v-col
          v-for="(colIndex, j) in daysOfWeek"
          :key="'dayColIndex-' + colIndex"
          class="ma-0 pa-0"
        >
          <v-btn
            block
            text
            dense
            :max-width="mobile ? '20px' : '40px'"
            color="primary"
            :disabled="!isIndexValid(i, j)"
            @click="setDay(getIndex(i, j))"
          >
            {{ isIndexValid(i, j) ? getIndex(i, j) : '' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
</style>
